import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../environments/environment.development";
import {Item} from "../../../users/interfaces/dashboard.interface";
import {Injectable} from "@angular/core";
import {AsignacionInterface, UsuarioAsignado} from "../interfaces/asignacion-interface";
import {LoginServices} from "../../../auth/login/services/login.service";
import {Param} from "../../../shared/interfaces/param-interface";

const apiVucUrl = environment.apiVucUrl

@Injectable({providedIn: 'root'})
export class AsignacionesService {
    constructor(private http: HttpClient, private loginServices: LoginServices) {
    }

    q1resumenGlobalDeEstados(params: Param[]) {
        let url = apiVucUrl + `api/v1.0/dashboard/funcionario/resumen-estados`;
        return this.http.post<Item[]>(url, params, {observe: 'response'});
    }

    q2resumenGlobalDeUsuarios(params: Param[]) {
        let url = apiVucUrl + `api/v1.0/dashboard/funcionario/resumen-usuarios`;
        return this.http.post<Item[]>(url, params, {observe: 'response'});
    }

    q4resumenGlobalPorTipoProyecto(params: Param[]) {
        let usuarios: string = "";
        let url = apiVucUrl + `api/v1.0/dashboard/funcionario/resumen-tipo-proyecto`;
        return this.http.post<Item[]>(url, params, {observe: 'response'});
    }

    q5resumenGlobalPorTipoTramite(params: Param[]) {
        let usuarios: string = "";
        let url = apiVucUrl + `api/v1.0/dashboard/funcionario/resumen-tipo-tramite`;
        return this.http.post<Item[]>(url, params, {observe: 'response'});
    }

    q6resumenGlobalPorSector(params: Param[]) {
        let usuarios: string = "";
        let url = apiVucUrl + `api/v1.0/dashboard/funcionario/resumen-sector`;
        return this.http.post<Item[]>(url, params, {observe: 'response'});
    }

    asignar(asignaciones: AsignacionInterface[]) {
        return this.http.post<AsignacionInterface[]>(apiVucUrl + `api/v1.0/asignaciones`, asignaciones, {observe: 'response'})
    }
    asignarSolicitudes(asignaciones: AsignacionInterface[]) {
        return this.http.post<AsignacionInterface[]>(apiVucUrl + `api/v1.0/asignaciones/solicitudes`, asignaciones, {observe: 'response'})
    }

    cancelar(asignaciones: AsignacionInterface[]) {
        return this.http.put<AsignacionInterface[]>(apiVucUrl + `api/v1.0/asignaciones`, asignaciones, {observe: 'response'})
    }

    consultarAsignacion(idProyecto: string | undefined) {
        return this.http.get<UsuarioAsignado[]>(apiVucUrl + `api/v1.0/asignaciones?idProyecto=${idProyecto}`, {observe: 'response'})
    }

    consultaTodos(params: Param[]) {
        return this.http.post<UsuarioAsignado[]>(apiVucUrl + `api/v1.0/asignaciones/usuarios`, params, {observe: 'response'})
    }

    consultarAsignacionProgreso(idProyecto: number) {
        return this.http.get<UsuarioAsignado[]>(apiVucUrl + `api/v1.0/asignaciones/consultar/proyecto/usuarios-progreso?idProyecto=${idProyecto}`, {observe: 'response'})
    }
}
